import { Renovation } from '@search/filter-enums/enums/Renovation';

export function offerSearchTextRenovation({
    renovation
}: {
    renovation: readonly Renovation[];
}) {
    const renovationType = renovation.length === 1 ? renovation[0] : undefined;

    switch (renovationType) {
        case Renovation.EURO: return 'евроремонт';
        case Renovation.COSMETIC: return 'косметический';
        case Renovation.DESIGNED: return 'дизайнерский';
        case Renovation.NEED: return 'нужен ремонт';
        case Renovation.NONE: return 'без ремонта';
        default: return '';
    }
}
